import axios from "axios"
import { PROFILE_ENDPOINTS } from "./endpoints"
import { ProfileDetails, ProfileResponse } from "../types"

export const getProfileService = async () => {
  try {
    const response = await axios(PROFILE_ENDPOINTS.GET_PROFILE)
    return response?.data?.data as ProfileResponse['data']
  } catch (error) {
    throw error
  }
}

export const updateProfileService = async (data: Partial<ProfileDetails>) => {
  try {
    const response = await axios.put(PROFILE_ENDPOINTS.UPDATE_PROFILE, data)
    return response?.data?.data as ProfileResponse['data']
  } catch (error) {
    throw error
  }
}

export const uploadImage = async (formData: unknown) => {
  try {
    const response = await axios.post(PROFILE_ENDPOINTS.UPLOAD_FILE, formData)
    return response?.data
  } catch (error) {
    throw error
  }
}

export const adminActivityService = async (data: { status: string | undefined, page: number, limit: number, q?: string, startDate?: string, endDate?: string }) => {
  try {
    const response = await axios(PROFILE_ENDPOINTS.ADMIN_ACTIVITY, { params: data })
    return response?.data
  } catch (error) {
    throw error
  }
}

export const adminPreferenceService = async (data: {
  defaultModuleOnLogin?: string,
  totalItemPerpage?: number, sendLoginNotification?: boolean,
}) => {
  try {
    const response = await axios.put(PROFILE_ENDPOINTS.ADMIN_PREFERENCE, data)
    return response?.data
  } catch (error) {
    throw error
  }
}

export const adminChangePasswordService = async (data: { oldPassword: string, newPassword: string, mfaCode: string }) => {
  try {
    const response = await axios.post(PROFILE_ENDPOINTS.ADMIN_CHANGE_PASSWORD, data)
    return response?.data
  } catch (error) {
    throw error
  }
}

export const getAdminSessionService = async () => {
  try {
    const response = await axios(PROFILE_ENDPOINTS.GET_ADMIN_SESSION)
    return response?.data
  } catch (error) {
    throw error
  }
}

export const logoutAdminSessionService = async (sessionId: string) => {
  try {
    const response = await axios.delete(PROFILE_ENDPOINTS.LOGOUT_ADMIN_SESSION)
    return response?.data
  } catch (error) {
    throw error
  }
}

export const logoutAllAdminSessionService = async () => {
  try {
    const response = await axios.delete(PROFILE_ENDPOINTS.LOGOUT_ALL_ADMIN_SESSION)
    return response?.data
  } catch (error) {
    throw error
  }
}

export const regenrateBackupCodeService = async ({mfaCode}: {mfaCode: string}) => {
  try {
    const response = await axios.post(PROFILE_ENDPOINTS.ADMIN_REGENERATE_BACKUP_CODES, {mfaCode})
    return response?.data
  } catch (error) {
    throw error
  }
}


export const resetMfaService = async ({ mfaCode }: { mfaCode: string }) => {
  try {
    const response = await axios.post(PROFILE_ENDPOINTS.ADMIN_MFA_RESET, { mfaCode })
    return response?.data
  } catch (error) {
    throw error
  }
}

export const handleExportActivityLog = async () => {
  try {
    const response = await axios.get(PROFILE_ENDPOINTS.EXPORT_ACTIVITY)
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'activity.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return response?.data
  } catch (error) {
    throw error
  }
}